export default {
  component: () => import('./page.vue'),
  path: '/help',
  name: 'help',
  meta: {
    title: '使用帮助',
    auth: true,
  },
};
